/* global G */
import { curry, isStr, type PlatformEvent } from 'lib/util'
import status, { BatteryStatus } from 'model/_shared/collection/bluetooth/battery'

/**
 * List Battery Status Event Handler
 *
 * @param module - app module
 * @param component - action component
 * @param eventOrKey - status key or event with key as detail
 * @returns battery statuses
 */
const listBatteryStatus = (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  eventOrKey: PlatformEvent<{ key: string }> | string | null,
): BatteryStatus[] => {
  const key = !eventOrKey || isStr(eventOrKey) ? eventOrKey : eventOrKey.detail.key
  return key ? status.filter(item => item.key === key) : status
}

export default curry(listBatteryStatus)
